import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { get_shared_chart_data } from './utils/retrieve_view';
import { Box, Chip } from '@mui/material';
import FullyIntegratedTimelineChart from '../../common/components/Chart/FullyIntegratedTimelineChart';
import { shareable_createPaginatedData } from '../../common/components/Chart/utils/shareable_chart_pagination_data_creator';
import { calculateRemainingHeight } from '../../util';

const ShareableChart = () => {
  const { view } = useParams();
  const { id } = useParams();
  const [x_key_name] = useState((() => {
    switch (view) {
      case "machine_view":
        return "machine_id";
      case "analyst_view":
        return "analyst_id";
      case "product_view":
        return "batch_no";
      default:
        return "machine_id";
    }
  })());
  useEffect(() => {
    console.log({ x_key_name });
  }, [x_key_name]);
  const [loading_data, set_loading_data] = useState(false);
  const [shared_view_state, set_shared_view_state] = useState({
    data: null,
    columns: null,
    table_data: null,
    paginated_data: null,
    paginated_data_copy: null,
    formatted_json_data: null,
    selected_secondary_names_chart_view: null
  });

  const [color_by, set_color_by] = useState("spec_id");
  const color_by_options = ["spec_id", "machine_id", "analyst_required", "test_id", "step_name"];

  const update_color_by = (new_color_by) => {
    set_color_by(new_color_by);
  };

  const [selected_primary_names_chart_view, set_selected_primary_names_chart_view] = useState([]);
  const [selected_secondary_names_chart_view, set_selected_secondary_names_chart_view] = useState({});

  const [filtered_in, set_filtered_in] = useState({
    machine_view: {
      primary: false,
      secondary: false,
    },
    analyst_view: {
      primary: false,
      secondary: false,
    },
    product_view: {
      primary: false,
      secondary: false,
    },
  });

  const [, set_error_message] = useState("");
  const [data_loaded, set_data_loaded] = useState(false);
  const fetch_and_update_data_state = async () => {
    set_loading_data(true);
    const response = await get_shared_chart_data(id);
    // let colorBy = "spec_id";
    console.log({ response });
    const paginated_data = shareable_createPaginatedData(x_key_name, response.result.formatted_json_data, color_by);
    response.result.paginated_data = paginated_data;
    response.result.paginated_data_copy = paginated_data;
    if (response.error !== false) {
      set_error_message(response.error);
    }
    else {
      set_shared_view_state(response.result);
    }
    set_loading_data(false);
  };

  useEffect(() => {
    fetch_and_update_data_state();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log({ shared_view_state });
    if (shared_view_state.selected_secondary_names_chart_view !== null) {
      console.log("updating secondary filter keys");
      set_selected_secondary_names_chart_view(shared_view_state.selected_secondary_names_chart_view);
    }
  }, [shared_view_state]);

  useEffect(() => {
    if (Object.keys(selected_secondary_names_chart_view).length > 0) {
      console.log("updated secondary filter keys");
      console.log(selected_secondary_names_chart_view);
      set_data_loaded(true);
    }
  }, [selected_secondary_names_chart_view]);

  const [updating_chart_data, set_updating_chart_data] = useState(false);

  useEffect(() => {
    console.log({ filtered_in });
    if (data_loaded) {
      if (filtered_in.machine_view.primary) {
        set_selected_secondary_names_chart_view({
          ...shared_view_state.selected_secondary_names_chart_view
        });
      } else if (filtered_in.machine_view.secondary) {
        set_selected_primary_names_chart_view([]);
      }
      if (filtered_in.analyst_view.primary) {
        set_selected_secondary_names_chart_view({
          ...shared_view_state.selected_secondary_names_chart_view
        });
      } else if (filtered_in.analyst_view.secondary) {
        set_selected_primary_names_chart_view([]);
      }
      if (filtered_in.product_view.primary) {
        set_selected_secondary_names_chart_view({
          ...shared_view_state.selected_secondary_names_chart_view
        });
      } else if (filtered_in.product_view.secondary) {
        set_selected_primary_names_chart_view([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtered_in]);

  useEffect(() => {
    if (data_loaded) {
      set_selected_primary_names_chart_view([]);
      set_updating_chart_data(true);
      set_shared_view_state((prev) => {
        const temporary_obj = { ...prev };
        temporary_obj.paginated_data = null;
        temporary_obj.paginated_data_copy = null;
        return temporary_obj;
      });
      setTimeout(() => {
        let chart_view_paginated = null;
        if (shared_view_state.formatted_json_data !== null) {
          chart_view_paginated = shareable_createPaginatedData(x_key_name, shared_view_state.formatted_json_data, color_by);
          // console.log({ machine_view_paginated });
        }
        set_shared_view_state((prev) => {
          const temporary_obj = { ...prev };
          temporary_obj.paginated_data = chart_view_paginated;
          temporary_obj.paginated_data_copy = chart_view_paginated;
          return temporary_obj;
        });
        set_updating_chart_data(false);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color_by]);

  return (
    <div>
      <Box className="w-full flex items-center justify-center gap-2 p-3 flex-wrap">
        <Chip label={`View : ${view.split("_").join(" ")}`} />
        <Chip label={`ID: ${id}`} />
      </Box>
      <Box>
        {loading_data ?
          <Box className={`flex justify-center items-center text-lg`} sx={{ height: calculateRemainingHeight(200) }}>
            <p className='capitalize'>Downloading {view.split("_").join(" ")} Data... Please Wait...</p>
          </Box> :
          (updating_chart_data && data_loaded) ?
            <Box className={`flex justify-center items-center text-lg`} sx={{ height: calculateRemainingHeight(100) }}>
              <p>Updating Chart Data... Please Wait...</p>
            </Box> :
            data_loaded &&
            <Box className="flex justify-center items-center p-2 w-full" sx={{
              // height: calculateRemainingHeight(50)
            }}>
              <Box className="w-full">
                <FullyIntegratedTimelineChart
                  color_by_options={color_by_options}
                  selected_color={color_by}
                  update_color_by={update_color_by}
                  paginated_x_view_data={shared_view_state.paginated_data}
                  data_copy_for_filtering={shared_view_state.paginated_data_copy}
                  update_data_copy_for_filtering={(data) => {
                    set_shared_view_state((prev) => {
                      const temp = { ...prev };
                      temp.paginated_data_copy = data;
                      return temp;
                    });
                  }}
                  x_key_name={x_key_name}
                  formatted_json_data={shared_view_state.formatted_json_data}
                  columns={shared_view_state.columns}
                  table_data={shared_view_state.table_data}
                  selected_primary_names={selected_primary_names_chart_view}
                  set_selected_primary_names={set_selected_primary_names_chart_view}
                  primary_filter_name={Object.keys(selected_secondary_names_chart_view)[0]}
                  secondary_filter_name={Object.keys(selected_secondary_names_chart_view)[1]}
                  selected_secondary_filters={selected_secondary_names_chart_view}
                  set_selected_secondary_filters={set_selected_secondary_names_chart_view}
                  set_filtered_in={set_filtered_in}
                  view_name={view}
                />
              </Box>
            </Box>
        }
      </Box>
    </div>
  );
};

export default ShareableChart;